<template>
  <div class="device">
    <div class="search">
      <!-- 普通用户-所有设备 -->
      <!-- {{$t('device.device_status')+'：'}} -->
      <el-select
        v-model="search.status"
        clearable
        @change="getDeviceList(true)"
        :placeholder="$t('device.device_status')"
        popper-class="select-search"
      >
        <el-option
          v-for="(item,key) in $filter.deviceStatus"
          :key="key"
          :value="key"
          :label="item.label"
          style="display:flex;padding-left:40px;;align-items:center;"
        >
          <i style="width:10px;height:10px;margin-right:8px;" :class="item.class"></i>
          <span class="select-label">{{item.label}}</span>
        </el-option>
      </el-select>
      <!-- {{$t('device.device_type')+'：'}} -->
      <el-select
        v-model="search.brand"
        clearable
        @change="getDeviceList(true)"
        :placeholder="$t('device.device_type')"
        popper-class="select-search"
      >
        <el-option
          v-for="item in $filter.deviceType"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <el-input
        v-model="search.pn"
        clearable
        @keyup.enter.native="getDeviceList(true)"
        :placeholder="this.$t('device.datalogger_pn')"
        popper-class="select-search"
      ></el-input>
      <el-input
        v-model="search.search"
        @keyup.enter.native="getDeviceList(true)"
        :placeholder="this.$t('device.Sn_deviceName')"
        popper-class="select-search"
        clearable
      ></el-input>
      <button class="button-solid button" @click="getDeviceList">
        <i class="el-icon-search"></i>
      </button>
    </div>
    <div class="sections">
      <div class="table">
        <el-table
          :data="deviceList"
          border
          stripe
          height="100%"
          :row-style="{height:0}"
          :cell-style="{padding:0}"
          :header-cell-style="{background:'#F2F5F7',color:'#606266'}"
          v-loading="loadingdevice"
          element-loading-spinner="el-icon-loading"
          @selection-change="changeFun"
        >
          <!-- :empty-text="$t('message.nodata')" -->
          <el-table-column fixed type="selection"></el-table-column>
          <el-table-column
            fixed
            prop="devalias"
            min-width="185px;"
            :label="$t('device.device_name')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                class="redirect"
                @click="enterDevice(scope.row)"
                :title="scope.row.devalias||scope.row.sn"
              >{{scope.row.devalias||scope.row.sn}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sn"
            min-width="185px;"
            :label="$t('device.device_sn')"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="status"
            min-width="120px;"
            :label="$t('device.device_status')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.status!==undefined"
                :class="`color-${$filter.deviceStatus[scope.row.status].name}`"
              >{{$filter.deviceStatus[scope.row.status].label}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="brand"
            min-width="115px;"
            :label="$t('device.device_type')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">{{scope.row.brand | translateDeviceType}}</template>
          </el-table-column>
          <el-table-column
            width="90px;"
            prop="devcode"
            :label="$t('device.device_code')"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="pn"
            min-width="140px;"
            :label="$t('device.datalogger_pn')"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="devaddr"
            min-width="135px;"
            :label="$t('device.device_address')"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="profitToday"
            min-width="120px;"
            :label="$t('device.Today_income')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{scope.row.profitToday | formatNum(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="profitTotal"
            min-width="150px;"
            :label="$t('device.Cumulative_income')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{scope.row.profitTotal | formatNum(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="collalias"
            min-width="140px;"
            :label="$t('device.coll_alias')"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            width="115px;"
            :label="$t('device.device_model')"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span :title="scope.row.devtype||'--'">{{scope.row.devtype||'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="this.$t('device.Operation')" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation"
                :title="$t('device.edit')"
                @click="editDevice(scope.row)"
              >
                <i class="iconfont icon-edit1"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.debug')"
                @click="debugDevice(scope.row)"
              >
                <i class="iconfont icon-tiaoshi"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.control')"
                @click="controlDevice(scope.row)"
              >
                <i class="iconfont icon-maintain"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.upgrade')"
                @click="upgradeDevice(scope.row)"
              >
                <i class="iconfont icon-upgrade"></i>
              </el-button>
              <el-button
                type="text"
                class="operation"
                :title="$t('device.delete')"
                @click="deleteDevice(scope.row)"
              >
                <i class="iconfont icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
          <div v-show="emptyText" slot="empty">
            <img src="@/assets/img/empty_text.png" />
            <div style="line-height: 32px">{{$t('account.nodata')}}</div>
          </div>
        </el-table>
      </div>
      <div class="tablebottom">
        <button
          :class="{'button-disable':!pagination.total, 'button-solid': pagination.total}"
          class="button"
          @click="statisticDialogVisible=!!pagination.total"
        >{{$t('device.statistic')}}</button>
        <!-- <button class="button" :class="selectedAlarm.length ? 'button-solid' : 'button-disable'"
        @click="detelealarm(selectedAlarm)">{{$t('alarm.Delete_selected')}}</button>-->
        <el-pagination
          class="pagination"
          v-show="paginationControl"
          background
          @size-change="getDeviceList(true)"
          @current-change="()=>getDeviceList()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10,15,20,30,50]"
          :page-size.sync="pagination.pagesize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
      <!-- 编辑设备 -->
      <device-dialog
        :title="$t('device.modify_alias')"
        :visible.sync="editDeviceVisible"
        v-if="editDeviceVisible"
      >
        <div slot="content">
          <el-form class="grid">
            <el-form-item :label="$t('device.serial_number')" prop="sn" size="small">
              <el-input v-model="formEdit.sn" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.device_code_form')" prop="devcode" size="small">
              <el-input v-model="formEdit.devcode" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.device_alias')" prop="devalias" size="small">
              <el-input v-model="formEdit.devalias" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <!-- <button class="button-hollow" @click="editDeviceVisible = false">{{$t('device.cancel')}}</button> -->
          <button class="button-solid" @click="submitEditDevice">{{$t('device.confirm')}}</button>
        </div>
      </device-dialog>
      <!-- 逆变器调试 -->
      <device-dialog
        :title="$t('device.debug')"
        :visible.sync="debugDeviceVisible"
        v-if="debugDeviceVisible"
      >
        <div slot="content">
          <el-form slot="content" class="grid">
            <el-form-item :label="$t('device.Device_pn')" size="small">
              <el-input v-model="device.pn" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.Instruction')" size="small">
              <el-input
                v-model="devDebug.cmd"
                :placeholder="$t('device.such_as')"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('device.return_content')" size="small">
              <el-input readonly v-model="debugReturn" type="textarea" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <button class="button-hollow" @click="qingkong()">{{$t('device.clear_data')}}</button>
          <button
            class="button-solid"
            type="primary"
            @click="submitDebugDevice()"
          >{{$t('device.send')}}</button>
        </div>
      </device-dialog>
      <!-- 控制项 -->
      <device-dialog
        :title="$t('device.control')"
        :width="'900px'"
        v-if="controlDeviceVisible"
        :visible.sync="controlDeviceVisible"
      >
        <div class="control" slot="content">
          <div v-if="tableDataBse.length">
            <div class="tableTitle">{{$t('createPlant.basic_settings')}}</div>
            <el-table
              :data="tableDataBse"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div v-if="tableDataStd.length">
            <div class="tableTitle">{{$t('createPlant.Standard_setting')}}</div>
            <el-table
              :data="tableDataStd"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataSvs.length">
            <div class="tableTitle">{{$t('createPlant.System_settings')}}</div>
            <el-table
              :data="tableDataSvs"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataPvs.length">
            <div class="tableTitle">{{$t('createPlant.Solar_settings')}}</div>
            <el-table
              :data="tableDataPvs"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataGrd.length">
            <div class="tableTitle">{{$t('createPlant.Grid_settings')}}</div>
            <el-table
              :data="tableDataGrd"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataBat.length">
            <div class="tableTitle">{{$t('createPlant.Battery_settings')}}</div>
            <el-table
              :data="tableDataBat"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataCts.length">
            <div class="tableTitle">{{$t('createPlant.Control_settings')}}</div>
            <el-table
              :data="tableDataCts"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataLos.length">
            <div class="tableTitle">{{$t('createPlant.Load_setting')}}</div>
            <el-table
              :data="tableDataLos"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
           <div v-if="tableDataBas.length">
            <div class="tableTitle">{{$t('createPlant.Basic_setting')}}</div>
            <el-table
              :data="tableDataBas"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length" popper-class="select-search-recharge">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-shuaxin"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataAdv.length">
            <div class="tableTitle">{{$t('createPlant.Advanced_setting')}}</div>
            <el-table
              :data="tableDataAdv"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length" popper-class="select-search-recharge">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-shuaxin"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-caozuo_tiaoshi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataElse.length">
            <div class="tableTitle">{{$t('createPlant.other_settings')}}</div>
            <el-table
              :data="tableDataElse"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column prop="name" :label="$t('device.Field_Name')" width="200px"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.controlvalue" v-if="scope.row.controlinter.length">
                    <el-option
                      v-for="item in scope.row.controlinter"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-input
                    v-model="scope.row.controlvalue"
                    v-else-if="scope.row.hint"
                    :placeholder="scope.row.hint"
                  ></el-input>
                  <el-input
                    v-model="scope.row.controlvalue"
                    :placeholder="scope.row.id==='system_time'&&'yyyy-MM-dd hh:mm:ss'"
                    v-else
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')">
                <template slot-scope="scope">
                  <div class="current-value">
                    <el-input v-model="scope.row.dangqianzhi"></el-input>
                    <el-button
                      v-loading="scope.row.isLoading"
                      @click="huoquInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-huoqudangqianzhi"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unit" :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                      <!-- element-loading-spinner="el-icon-loading" -->
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverter(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

           <div v-if="tableDataHuangJinTai.length">
            <div class="tableTitle">{{$t('createPlant.Battery_settings')}}</div>
            <el-table
              :data="tableDataHuangJinTai"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column :label="$t('device.Battery_voltage')">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.voltage" @change="huangjintaiChange">
                    <el-option
                      label="12V"
                      :value="12"
                    ></el-option>
                    <el-option
                      label="24V"
                      :value="24"
                    ></el-option>
                    <el-option
                      label="48V"
                      :value="48"
                    ></el-option>
                    <el-option
                      label="96V"
                      :value="96"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('device.Magnification')">
                <template slot-scope="scope">
                  <el-input
                  disabled
                    v-model="scope.row.multiply"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('device.Send_Command')">
                <template slot-scope="scope">
                  <div class="control-value">
                      <!-- element-loading-spinner="el-icon-loading" -->
                    <el-button
                      v-loading="scope.row.Loading"
                      @click="xiafaInverterHuangJinTai(scope.row)"
                      class="submit-control"
                    >
                      <i class="iconfont icon-zhilingxiafa"></i>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 无数据 -->
          <div v-if="noDataControl">
            <el-table
              height="50vh"
              stripe
              border
              :empty-text="$t('message.nodata')"
            >
              <el-table-column :label="$t('device.Field_Name')"></el-table-column>
              <el-table-column :label="$t('device.Operation')" width="200px"></el-table-column>
              <el-table-column width="220px" :label="$t('device.current_val')"></el-table-column>
              <el-table-column :label="$t('device.Unit')"></el-table-column>
              <el-table-column :label="$t('device.Send_Command')"></el-table-column>
            </el-table>
          </div>
        </div>
      </device-dialog>
      <!-- 固件升级 -->
      <device-dialog
        :title="$t('device.device_upgrade')"
        :visible.sync="upgradeDeviceVisible"
        v-if="upgradeDeviceVisible"
        width="580px"
      >
        <div slot="content">
          <el-form class="grid upload-container">
            <el-form-item :label="$t('device.select_firmware')" size="small">
              <el-select
                v-model="searchrecharge.firmware"
                @change="voltageArr($event)"
                :placeholder="$t('device.select_file')"
              >
                <el-option
                  v-for="item in rechargelist"
                  :key="item.value"
                  :label="item.firmware"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.firmware_type')" size="small">
              <el-select
                v-model="searchrecharge.firmwaretype"
                :placeholder="$t('device.select_type')"
              >
                <el-option
                  v-for="item in firmwaretypelist"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('device.upgrade_brate')" size="small">
              <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')">
                <el-option
                  v-for="item in bratelist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <div class="processstatueEquipment" v-show="progressUp">{{$t('firmware.upgrading')}}</div>
              <div
                class="processstatueEquipment"
                v-show="progerssComplete"
              >{{$t('firmware.updateCompleted')}}</div>
              <div class="upload-contents">
                <button class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                  <i class="iconfont icon-shangchuan"></i>
                  {{$t('device.Upload')}}
                </button>
                <div class="upload-tip">{{$t('firmware.limit0')}}</div>
              </div>
              <div class="progressShowEquipment" v-show="progressUp">
                <div class="progressName">
                  <i class="iconfont icon-fujian"></i>
                  {{firmwareName}}
                </div>
                <div class="progressCancel" @click="upgradeCancel">
                  <i class="iconfont icon-delete"></i>
                </div>
              </div>
              <div class="processDataEquipment" v-show="progressUp">
                <el-progress :format="progressText" :percentage="progress" :stroke-width="10"></el-progress>
                <div class="processBig">{{uploadNowSize}}M / {{uploadTotalSize}}M</div>
              </div>
              <input
                type="file"
                class="upload-input"
                ref="fileUploader"
                accept="application/octet-stream"
                @change="uploadfile($event)"
              />
              <div class="progerssCompleteEquipment" v-show="progerssComplete">
                <div class="progressName">
                  <i class="iconfont icon-fujian"></i>
                  {{firmwareName}}
                </div>
                <div class="progressCancel"></div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <!-- <button
            class="button-hollow"
            @click="upgradeDeviceVisible = false"
          >{{$t('device.cancel')}}</button>-->
          <button class="button-solid" @click="submitUpgradeDevice">{{$t('device.confirm')}}</button>
        </div>
      </device-dialog>
      <!-- 删除设备 去掉弹框的heard不加title=""和footer noFooter -->
      <device-dialog
        :visible.sync="deletingDeviceInfo"
        v-if="deletingDeviceInfo"
        width="30vw"
        noFooter
      >
        <div class="content_tishi" slot="content">
          <div class="tital">
            <i class="iconfont icon-gantanhao"></i>
            <span class="contentdelete">{{$t('device.confirm_deldte')}}</span>
          </div>
          <div class="disabledescr">{{$t('account.notRecovered')}}</div>
          <div class="deletfotter">
            <button class="button-solid" @click="submitDeleteDevice">{{$t('device.confirm')}}</button>
            <button class="button-hollow" @click="deletingDeviceInfo = null">{{$t('device.cancel')}}</button>
          </div>
        </div>
      </device-dialog>
      <!-- 协议统计 -->
      <statistic-dialog :visible.sync="statisticDialogVisible" v-if="statisticDialogVisible"></statistic-dialog>
    </div>
  </div>
</template>
<script>
import deviceDialog from "@/components/dialog";
import statisticDialog from "./statistic";
import { mapState } from 'vuex';
// import config from '@/assets/js/config';
export default {
  components: {
    deviceDialog,
    statisticDialog
  },
  data() {
    return {
      noDataControl: false,
      emptyText: false,
      paginationControl: false,
      progressUp: false,
      progress: 0,
      search: {
        status: "",
        brand: "",
        pn: "",
        search: ""
      },
      xieyi: [],
      file: null, //保存上传文件流的容器
      progerssComplete: false,
      uploadNowSize: "0.00", //现在正在上传的大小
      uploadTotalSize: "", //文件的总大小
      firmwareName: "",
      paramass: "", //中间变量
      searchrechargeContents: "", //选择固件时里面的内容
      searchrecharge: {
        firmware: "",
        firmwaretype: "0",
        brate: "0"
      },
      dataparams: "",
      rechargelist: [],
      firmwaretypelist: [
        {
          //通用固件
          id:11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id:12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id:13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id:14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id:15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id:16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0"
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400"
        },
        {
          label: 4800,
          value: "4800"
        },
        {
          label: 9600,
          value: "9600"
        },
        {
          label: 19200,
          value: "19200"
        },
        {
          label: 38400,
          value: "38400"
        },
        {
          label: 57600,
          value: "57600"
        },
        {
          label: 115200,
          value: "115200"
        }
      ],
      loadingdevice: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      }, //分页数据
      deviceList: [],
      selectedAlarm: [], //批量删除
      tableDataBse:[],
      tableDataStd:[],
      tableDataSvs:[],
      tableDataPvs:[],
      tableDataGrd:[],
      tableDataBat:[],
      tableDataCts:[],
      tableDataLos:[],
      tableDataBas:[],
      tableDataAdv:[],
      tableDataElse:[],
      tableDataHuangJinTai:[],//黄金台定制
      controlinter: [],
      controlvalue: "",
      editDeviceVisible: false,
      editDeviceInfo: null,
      debugDeviceVisible: false,
      debugDeviceId: null,
      upgradeDeviceVisible: false,
      upgradeDeviceterId: null,
      deletingDeviceInfo: null,
      controlDeviceVisible: false,
      statisticDialogVisible: false, //统计弹窗是否可见
      formEdit: {
        sn: "",
        pn: "",
        devaddr: "",
        devcode: "",
        alias: ""
      },
      device: {
        pn: ""
      },
      devDebug: {
        cmd: ""
      },
      debugReturn: "",
    };
  },
  watch: {
    // deleteDeviceVisible(val) {
    //   if (!val) this.deletingDeviceInfo = null;
    // },
    upgradeDeviceVisible(val) {
      if (!val) {
        clearInterval(this.interval);
        this.interval = null;
        this.progressUp = false;
      }
    }
  },
  created() {
    this.getDeviceList();
  },
  computed:{
            ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  methods: {
    progressText(progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    //获取表格数据
    getDeviceList(reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        ...this.search,
        devtype: 2304,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      };
      this.loadingdevice = true;
      this.$request.get("webQueryDeviceEs", param).then(res => {
        if (res.err == 0) {
          this.deviceList = res.dat.device;
          this.pagination.total = res.dat.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true;
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.deviceList = [];
          this.pagination.total = 0;
        }
        this.loadingdevice = false;
      });
    },
    // 点击进入设备
    enterDevice(info) {
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr
      });
    },
    editDevice(info) {
      // 编辑设备
      this.editDeviceVisible = true;
      this.formEdit = { ...info };
    },
    // 确定修改逆变器
    submitEditDevice() {
      let param = {
        pn: this.formEdit.pn,
        sn: this.formEdit.sn,
        devaddr: this.formEdit.devaddr,
        devcode: this.formEdit.devcode,
        alias: this.formEdit.devalias
      };
      this.$request.get("editDeviceInfo", param).then(res => {
        if (res.err == 0) {
          this.$message.success(this.$t("device.modifySuc"));
          this.formEdit = {};
          // 通知设备列表更新
          this.$store.state.event.updateDeviceList = true;
          this.getDeviceList();
          this.editDeviceVisible = false;
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      });
    },
    // 调试设备
    debugDevice(info) {
      this.devDebug.cmd = null;
      this.debugReturn = null;
      this.debugDeviceVisible = true;
      // this.debugDeviceId = id;
      this.$request
        .get("queryDeviceInfo", {
          device:
            info.pn + "," + info.devcode + "," + info.devaddr + "," + info.sn
        })
        .then(res => {
          if (res.err === 0) {
            // this.debugDeviceVisible = true,
            // this.getDeviceList();
            this.device = res.dat[0];
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    // 调试清空
    qingkong() {
      this.devDebug.cmd = null;
      this.debugReturn = null;
    },
    // 发送指令
    submitDebugDevice() {
      if (this.device.status == "1") {
        this.$message.error(this.$t("device.Debugfail"));
      } else {
        this.debugReturn = this.$t("device.instruction_response");
        let param = {
          pn: this.device.pn,
          devaddr: this.device.devaddr,
          cmd: this.devDebug.cmd
        };
        this.$request.get("sendCmdToDevice", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.debug_suc"));
            this.debugReturn = res.dat.dat;
            // this.debugDeviceVisible = false;
            // this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
            this.debugReturn = null;
          }
        });
      }
    },
    // 控制项
    controlDevice(info) {
      this.controlDeviceVisible = true;
      this.noDataControl = false;
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
     i18n: this.$lang.currentLang,
             role:1,
        accountType:this.$store.state.user.role == 0? 3 : this.$store.state.user.role,
        userId:this.$store.state.user.uidExtra
      };
      this.controlparams = info;
       let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceCtrlStrategy" : "queryDeviceCtrlField";
      this.$request[this.method](url, param).then(res => {
        if (res.err == 0) {
          let tableData = res.dat.field;
          let arr1 = [],arr2 = [],arr3 = [],arr4 = [],arr5 = [],arr6 = [],arr7 = [],arr8 = [],arr9 = [],arr10=[],arr11=[];
          tableData.forEach(field => {
            field.controlinter = [];
            if (field.item) {
              field.item.forEach(item => {
                field.controlinter.push({
                  label: item.val,
                  value: item.key
                });
              });
              //默认显示第一项
              // field.controlvalue = field.item.length ? field.controlinter[0].value: "";
              //不显示任由选择
              field.controlvalue = "";
            }
            var s = field.id;
            if (s.startsWith("bse_")) {
              arr1.push(field)
            } else if (s.startsWith("std_")) {
              arr2.push(field)
            } else if (s.startsWith("sys_")) {
              arr3.push(field)
            } else if (s.startsWith("pvs_")) {
              arr4.push(field)
            } else if (s.startsWith("grd_")) {
              arr5.push(field)
            } else if (s.startsWith("bat_")) {
              arr6.push(field)
            } else if (s.startsWith("cts_")) {
              arr7.push(field)
            } else if (s.startsWith("los_")) {
              arr8.push(field)
            } else if (s.startsWith("bas_")) {
              arr10.push(field)
            } else if (s.startsWith("adv_")) {
              arr11.push(field)
            } else {
              arr9.push(field)
            }
            // this.huoquInverter(field)
          });
          this.tableDataAdv = arr11;
          this.tableDataBas = arr10;
          this.tableDataElse = arr9;
          this.tableDataLos = arr8;
          this.tableDataCts = arr7;
          this.tableDataBat = arr6;
          this.tableDataGrd = arr5;
          this.tableDataPvs = arr4;
          this.tableDataSvs = arr3;
          this.tableDataStd = arr2;
          this.tableDataBse = arr1;
        }else{
          this.noDataControl = true;
          this.tableDataAdv = [];
          this.tableDataBas = [];
          this.tableDataElse = [];
          this.tableDataLos = [];
          this.tableDataCts = [];
          this.tableDataBat = [];
          this.tableDataGrd = [];
          this.tableDataPvs = [];
          this.tableDataSvs = [];
          this.tableDataStd = [];
          this.tableDataBse = [];
        }
      });
      //黄金台设备调用下方黄金台定制funtcion
      if(info.devcode == 2384){
        this.getHuangjintaiControl(info)
      }else if (info.devcode == 2366){
        this.getHuangjintaiControl(info)
      }else{
        this.tableDataHuangJinTai = [];
      }
    },
    //黄金台定制,获取电池电压和倍率
    getHuangjintaiControl(info){
      let param = {
        pn: info.pn,
        sn: info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
      };
      this.$request.get("queryCtrlHuangJinTaiView", param).then(res => {
        if (res.err == 0) {
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: res.dat.voltage,
            multiply: res.dat.multiply
          })
        }else if(res.err == 8){
          this.tableDataHuangJinTai = [];
          this.tableDataHuangJinTai.push({
            voltage: 12,
            multiply: 0.09
          })
        }else{
          this.tableDataHuangJinTai = []
        }
      })
    },
    huangjintaiChange(val){
      var volArr = [{key:'12V',val:12},{key:'24V',val:24},{key:'48V',val:48},{key:'96V',val:96}]
      var mulArr = [{key:'0.09',val:0.09},{key:'0.18',val:0.18},{key:'0.36',val:0.36},{key:'0.72',val:0.72}]
      volArr.forEach((element,index) => {
        if(element.val == val){
          this.tableDataHuangJinTai[0].multiply = mulArr[index].val;
        }
      });
    },
    // 控制项获取当前值
    huoquInverter(info) {
      let param = {
        pn: this.controlparams.pn,
        sn: this.controlparams.sn,
        devcode: this.controlparams.devcode,
        devaddr: this.controlparams.devaddr,
        id: info.id,
        i18n: this.$lang.currentLang
      };
      this.$set(info,'isLoading',true)
      // info.isLoading = true;
      this.$request.get("queryDeviceCtrlValue", param).then(res => {
        if (res.err == 0) {
          // info.dangqianzhi = res.dat.val;
          this.$set(info,'dangqianzhi',res.dat.val)
        } else {
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
        // info.isLoading = false;
        this.$set(info,'isLoading',false)
      }).catch(() => {
          this.$set(info, "isLoading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
    },
    // 下发指令(黄金台)
    xiafaInverterHuangJinTai(info){
      let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          voltage:info.voltage,
          multiply:info.multiply
        };
        // info.Loading = true;
        this.$set(info,'Loading',true)
        this.$request.get("ctrlHuangJinTaiView", param).then(res => {
          if (res.err == 0) {
              this.$message.success(this.$t("device.Send_suc"));
          } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
          }
          // info.Loading = false;
          this.$set(info,'Loading',false)
        });
    },
    // 下发指令
    xiafaInverter(info) {
      if (!info.controlvalue) {
        this.$message.error(this.$t("device.Send_Input"));
      } else {
        let param = {
          pn: this.controlparams.pn,
          sn: this.controlparams.sn,
          devcode: this.controlparams.devcode,
          devaddr: this.controlparams.devaddr,
          id: info.id,
          val: info.controlvalue,
          i18n: this.$lang.currentLang
        };
        this.$set(info,'Loading',true)
        // info.Loading = true;
        this.$request.get("ctrlDevice", param).then(res => {
        // this.$request.get("ctrlDevice", param).then(res => {
          if (res.err == 0) {
            if (this.controlparams.devcode == 2352) {
              var medium = res.dat.dat.substring(27, 29);
              if (medium == "31") {
                this.$message.success(this.$t("device.Send_suc"));
              } else {
                this.$message.error(this.$t("device.Send_fail"));
              }
            } else {
              this.$message.success(this.$t("device.Send_suc"));
            }
          } else {
            if (this.controlparams.devcode == 2376) {
              if(res.desc.match(/\(([^)]*)\)/)){
                this.$message.error(res.desc.match(/\(([^)]*)\)/)[1]);
              }else{
                const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
                this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
              }
            } else {
              const errMsg = this.$t(`controlDeviceErrCode.${res.err}`);
              this.$message.error(errMsg.includes('controlDeviceErrCode') ? this.$t("device.Send_fail") : errMsg);
            }
            // this.$message.error(this.$t(`errCode.${res.err}`));
          }
          // info.Loading = false;
          this.$set(info,'Loading',false)
        }).catch(() => {
          this.$set(info, "Loading", false);
          this.$message.error(this.$t(`errCode.3`));
        });
      }
    },
    voltageArr(item) {
      this.rechargelist.forEach(element => {
        if (element.id == item) {
          this.searchrechargeContents = element;
        }
      });
    },
    // 设备固件升级
    upgradeDevice(info) {
      this.queryFirmware();
      this.upgradeDeviceVisible = true;
      this.dataparams = info;
      this.progerssComplete = false;
    },
    // 查询固件列表
    queryFirmware() {
      this.searchrecharge.firmware = null;
      this.rechargelist = [];
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", { pagesize: 50 }).then(res => {
        if (res.code == 0) {
          res.data.items.forEach(item => {
            this.rechargelist.push({
              id: item.id,
              firmware: item.firmware,
              size: item.size
            });
          });
        }
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile(event) {
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
      });
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("device.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("device.error1"));
        return;
      }
      this.$request.uploadfileAxios(file).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("device.uploadSuccess"));
          // this.upgradeDeviceVisible = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("device.error1"));
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
        }
        this.queryFirmware();
        // this.upgradeDeviceVisible = false;
      });
    },
    // 确认固件升级
    submitUpgradeDevice() {
      // console.log("this.searchrechargeContents", this.searchrechargeContents);
      this.progress = 0;
      if (!this.searchrecharge.firmware) {
        this.$message.error(this.$t("device.file_fist"));
      } else if (this.dataparams.status == "1") {
        this.$message.error(this.$t("device.updatefail"));
      } else {
        this.firmwareName = this.searchrechargeContents.firmware;
        this.uploadTotalSize = this.$filter.formatNum(
          this.searchrechargeContents.size / (1024 * 1024),
          2
        );
        let params = {
          pn: this.dataparams.pn,
          devaddr: this.dataparams.devaddr,
          devcode: this.dataparams.devcode,
          sn: this.dataparams.sn,
          firmwareId: this.searchrecharge.firmware,
          firmwareType: this.searchrecharge.firmwaretype,
          baudrate: this.searchrecharge.brate
        };
        this.$request.postUPG("/upg/api/auth/web/shineDess/device/upgrade/firmwareUpgradeDevice", params).then(res => {
          if (res.code == 0) {
            if (res.data.ret == 0) {
              this.keyProgress = res.data.key;
              this.$message.success(this.$t("device.Upgrading"));
              // this.$message.success(this.$t("device.update_suc"));
              this.queryProgress();
            } else if (res.data.ret == 1) {
              this.$message.error(this.$t("device.System_Failed"));
            } else if (res.data.ret == 2) {
              this.$message.error(this.$t("device.Device_Offline"));
            } else if (res.data.ret == 3) {
              this.$message.error(this.$t("device.In_Upgrading"));
            }
            // this.upgradeDeviceVisible = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.code}`));
            this.$message.error(res.message);
          }
        });
      }
    },
    // 查询升级进度
    queryProgress() {
      this.progressUp = true;
      this.progerssComplete = false;
      let params = {
        pn: this.dataparams.pn,
        devaddr: this.dataparams.devaddr,
        devcode: this.dataparams.devcode,
        sn: this.dataparams.sn,
        key: this.keyProgress
      };
      // 如果已存在定时器，先清除
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      this.interval = setInterval(() => {
        this.$request.getUPG("/upg/api/auth/web/shineDess/device/upgrade/queryDeviceFirmwareUpgradeProgress", params)
          .then(res => {
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress =
                  this.$filter.formatNum(res.data.progress / 10, 0) - 0;
                this.progress = progress;
                // this.progressText = progress + "%";
                this.uploadNowSize = this.$filter.formatNum(
                  (this.uploadTotalSize * progress) / 100,
                  2
                );
                if (this.progress >= 100) {
                  clearInterval(this.interval);
                  this.interval = null;
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.$message.success(this.$t("device.Update_Completed"));
                  setTimeout(() => {
                    this.upgradeDeviceVisible = false;
                  }, 2000);
                  return;
                }
              } else if (res.data.status == 1) {
                this.$message.error(this.$t("firmware.upgrade_quit1"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 2) {
                this.$message.error(this.$t("firmware.upgrade_quit2"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 3) {
                this.$message.error(this.$t("firmware.upgrade_quit3"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 4) {
                this.$message.error(this.$t("firmware.upgrade_quit4"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              } else if (res.data.status == 5) {
                this.$message.error(this.$t("firmware.upgrade_quit5"));
                clearInterval(this.interval);
                this.interval = null;
                this.upgradeDeviceVisible = false;
                return;
              }
            } else {
              // this.$message.error(this.$t(`errCode.${res.code}`));
              this.$message.error(res.message);
              clearInterval(this.interval);
              this.interval = null;
            }
          });
      }, 2000);
    },
    //取消升级
    upgradeCancel() {
      this.$request.putUPG("/upg/api/auth/web/shineDess/device/upgrade/deviceCancelFirmwareUpgrade", {
          pn: this.dataparams.pn,
          key: this.keyProgress
        })
        .then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
          } else if (res.code == 3 || res.code == 1) {
            this.upgradeDeviceVisible = false;
          } else {
            this.$message.error(this.$t("firmware.FailedCancelUpgrade"));
          }
        });
    },
    deleteDevice(info) {
      this.deletingDeviceInfo = {
        pn: info.pn,
        devaddr: info.devaddr,
        devcode: info.devcode,
        sn: info.sn
      };
    },
    // 确定删除设备
    submitDeleteDevice() {
      this.$request
        .get("delDeviceFromPlant", this.deletingDeviceInfo)
        .then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("device.deleteSuc"));
            this.deletingDeviceInfo = null;
            this.getDeviceList();
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
    //勾选多项
    changeFun(val) {
      this.selectedAlarm = val; // 返回的是选中的列的数组集合
    }
  }
};
</script>
<style lang="less" scoped>
.device {
  // padding: 15px 25px;
  display: flex;
  overflow: auto;
  flex: 1;
  flex-direction: column;
  .search {
    font-size: 14px;
    margin-top: 20px;
    .button-create {
      float: right;
    }
  }
  .sections {
    margin: 0 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .table {
      flex: 1;
      overflow: auto;
      /deep/.el-icon-loading {
        font-size: 28px;
      }
    }
    .current-value {
      display: flex;
      .el-input {
        flex: 1;
        margin-right: 3px;
      }
      .submit-control {
        i {
          font-size: 18px;
        }
        padding: 5px 12px;
      }
    }
    .control-value {
      .submit-control {
        padding: 6px 20px;
        i {
          font-size: 18px;
        }
      }
    }
    .control {
      height: 50vh;
      .el-table{
        margin-bottom: 20px;
        /deep/ tr td:first-child .cell {
          text-align: left;
        }
      }
      .tableTitle {
        margin-bottom: 5px;
        // padding: 20px 0 5px;
        font-size: 16px;
        color: #595959;
        font-weight: bold;
      }
    }
  }
  .active {
    color: #26ae3c;
  }
  .inactive {
    color: #c9c9c9;
  }
  .upload-input {
    display: none;
  }
  .tablebottom {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    // text-align: center;
    button {
      // float: left;
      margin-top: 20px;
      height: 32px;
      line-height: 32px;
      padding: 0 30px;
    }
  }
  .contentdelete {
    font-size: 20px;
    font-weight: 600;
  }
  .deletfotter {
    margin-top: 50px;
    .button-hollow {
      width: 100px;
      height: 40px;
      margin-right: 40px;
    }
    .button-solid {
      width: 100px;
      height: 40px;
    }
  }
}
</style>
